<div class="input-group">
  <input type="text" class="form-control" placeholder="Search" aria-label="Search" aria-describedby="search-button" [(ngModel)]="search" (ngModelChange)="searchChanged()">
  <button class="btn btn-outline-primary" type="button" id="search-button" (click)="onLoadResults()">
    <span class="bi bi-search"></span>
    <span class="visually-hidden">Search</span>
  </button>
</div>
